export enum AnalyticsEventType {
  Available = "available",
  Collapse_control_click = "collapse_control_click",
  Reveal_control_click = "reveal_control_click",
  Float_popup_close_button_pressed = "float_popup_close_button_pressed",
  Full_name_play_button_click = "full_name_play_button_click",
  Save_button_click = "save_button_click",
  Play_button_click = "play_button_click",
  Recording_select_list_change_to = "recording_select_list_change_to",
}
